import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { Menu, Transition } from "@headlessui/react";
import Select from "react-select";
import ReactPaginate from "react-paginate";
//import icone
import { RiSearch2Line } from "react-icons/ri";
import ClearFilter from "../../images/clear filter icon.png";
import LimitArrow from "../../images/LimitArrow.svg";
import Loader from "../../component/Admin/Loader";
import MasterAdminLayout from "../../component/layout/MasterLayout/MasterLayout";
import { ExportBranchData, GetAllBranchlist, GetMemberlist, MasterAdminLoader, MemberSendMail } from "../../Redux/Action/MasterAdminAction";
import UseOutsideClick from "../../component/Admin/UseOutsideClick";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import calender from "../../images/Doctor/calender.png";
import { components } from "react-select";
import { BiEdit } from "react-icons/bi";
import { AiOutlineMail } from "react-icons/ai";

const MemberList = () => {
  const location = useLocation();
  const history = useNavigate();
  const dispatch = useDispatch();
  const [selectpage, setselectpage] = useState("");
  const itemsPerPageOptions = [
    { value: 10, label: 10, id: 1 },
    { value: 25, label: 25, id: 2 },
    { value: 50, label: 50, id: 3 },
  ];

  const Employeelist = useSelector(
    (state) => state?.MasterAdmin?.MemberList?.data
  );

  useEffect(() => {
    searchParams.delete("search");
    searchParams.delete("corporateID");
    searchParams.delete("startDate");
    searchParams.delete("endDate");
    setSearchParams(searchParams);
    const sds = location.search.slice(1).split("&");

    let object = {};
    if (location.search.includes("?")) {
      sds.map((item) => {
        let newItem = item.split("=");
        object[newItem[0]] = newItem[1];
      });
    }
    delete object.search;
    delete object.corporateID;
    delete object.startDate;
    delete object.endDate;
    dispatch(GetMemberlist({ ...object }));
    dispatch(GetAllBranchlist());
  }, []);

  const [Itemperpage, setItemperpage] = useState("");
  const [page, setpage] = useState("");
  const pageCount = Math.ceil(Number(Employeelist?.count) / Number(page));

  useEffect(() => {
    if (pageCount && pageCount !== Infinity) {
      setItemperpage(pageCount);
    }
  }, [Employeelist]);

  useEffect(() => {
    setpage(itemsPerPageOptions[0]?.value);
  }, []);

  // for select page data
  const onselectedpage = (item) => {
    setpage(item.value);
  
    // Parse the current query string into an object
    const searchParams = new URLSearchParams(location.search);
    let params = {};
  
    searchParams.forEach((value, key) => {
      if (key === 'corporateID') {
        // If 'corporateID' already exists, append the new value
        params[key] = [...(params[key] || []), value];
      } else {
        // Otherwise, just set the value
        params[key] = value;
      }
    });
  
    // Ensure 'corporateID' is an array
    if (params.corporateID && !Array.isArray(params.corporateID)) {
      params.corporateID = [params.corporateID];
    }
  
    // Update the 'limit' and 'page' parameters
    params.limit = item.value;
    params.page = 1;
  
    // Construct the new query string
    const updatedSearchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach(val => updatedSearchParams.append(key, val));
      } else {
        updatedSearchParams.set(key, value);
      }
    });
  
    // Update the URL without reloading the page
    history({
      pathname: "/master/memberlist",
      search: "?" + updatedSearchParams.toString(),
    });
  
    // Dispatch the action to fetch the member list
    dispatch(GetMemberlist({ ...params, search: Search }));
  };

  // for pagination
  const handleFirstPage = () => {
    setselectpage(0);
  
    // Parse the current query string into an object
    const searchParams = new URLSearchParams(location.search);
    let params = {};
  
    searchParams.forEach((value, key) => {
      if (key === 'corporateID') {
        // If 'corporateID' already exists, append the new value
        params[key] = [...(params[key] || []), value];
      } else {
        // Otherwise, just set the value
        params[key] = value;
      }
    });
  
    // Ensure 'corporateID' is an array
    if (params.corporateID && !Array.isArray(params.corporateID)) {
      params.corporateID = [params.corporateID];
    }
  
    // Update the 'page' parameter
    params.page = 1;
  
    // Construct the new query string
    const updatedSearchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach(val => updatedSearchParams.append(key, val));
      } else {
        updatedSearchParams.set(key, value);
      }
    });
  
    // Update the URL without reloading the page
    history({
      pathname: "/master/memberlist",
      search: "?" + updatedSearchParams.toString(),
    });
  
    // Dispatch the action to fetch the member list
    dispatch(GetMemberlist({ ...params, page: 1 }));
  };
  
  const handleLastPage = () => {
    const lastPage = pageCount - 1;
    setselectpage(lastPage);
  
    // Parse the current query string into an object
    const searchParams = new URLSearchParams(location.search);
    let params = {};
  
    searchParams.forEach((value, key) => {
      if (key === 'corporateID') {
        // If 'corporateID' already exists, append the new value
        params[key] = [...(params[key] || []), value];
      } else {
        // Otherwise, just set the value
        params[key] = value;
      }
    });
  
    // Ensure 'corporateID' is an array
    if (params.corporateID && !Array.isArray(params.corporateID)) {
      params.corporateID = [params.corporateID];
    }
  
    // Update the 'page' parameter
    params.page = lastPage + 1;
  
    // Construct the new query string
    const updatedSearchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach(val => updatedSearchParams.append(key, val));
      } else {
        updatedSearchParams.set(key, value);
      }
    });
  
    // Update the URL without reloading the page
    history({
      pathname: "/master/memberlist",
      search: "?" + updatedSearchParams.toString(),
    });
  
    // Dispatch the action to fetch the member list
    dispatch(GetMemberlist({ ...params, page: lastPage + 1 }));
  };
   
  const handlePageChange = (selected) => {
    setselectpage(selected.selected);
    const sds = location.search.slice(1).split("&");
    let object = {};
  
    if (location.search.includes("?")) {
      sds.forEach((item) => {
        const [key, value] = item.split("=");
        if (key === "corporateID") {
          if (!object[key]) object[key] = [];
          object[key].push(value);
        } else {
          object[key] = value;
        }
      });
  
      const params = new URLSearchParams();
      for (const key in object) {
        if (Array.isArray(object[key])) {
          object[key].forEach(val => params.append(key, val));
        } else {
          params.set(key, object[key]);
        }
      }
      params.set("page", selected.selected + 1);
  
      history({
        pathname: "/master/memberlist",
        search: "?" + params.toString(),
      });
  
      dispatch(GetMemberlist({ ...object, page: selected.selected + 1, search: Search }));
    } else {
      history({
        pathname: "/master/memberlist",
        search: `?page=${selected.selected + 1}`,
      });
  
      dispatch(GetMemberlist({ page: selected.selected + 1, search: Search }));
    }
  };
  

  //for search filter
  const [Search, setSearch] = useState("");
  const submitsearch = (e) => {
    e?.preventDefault();
  
    const params = new URLSearchParams(location.search);
    const object = {};
  
    for (const [key, value] of params.entries()) {
      // For multiple corporateIDs like corporateID=1&corporateID=2
      if (key === "corporateID") {
        if (!object[key]) object[key] = [];
        object[key].push(value);
      } else {
        object[key] = value;
      }
    }
  
    delete object.page;
  
    const queryParams = new URLSearchParams();
    for (const key in object) {
      if (Array.isArray(object[key])) {
        object[key].forEach((val) => queryParams.append(key, val));
      } else {
        queryParams.set(key, object[key]);
      }
    }
  
    queryParams.set("search", Search);
    queryParams.set("page", 1);
  
    history({
      pathname: "/master/memberlist",
      search: `?${queryParams.toString()}`,
    });
  
    dispatch(
      GetMemberlist({
        ...object,
        search: Search,
        page: 1,
      })
    );
  };
  

  const [searchParams, setSearchParams] = useSearchParams();

  const removeQueryParams = () => {
    // Get all params including repeated ones like corporateID
    const params = new URLSearchParams(location.search);
    const object = {};
  
    for (const [key, value] of params.entries()) {
      if (key === "corporateID") {
        if (!object[key]) object[key] = [];
        object[key].push(value);
      } else {
        object[key] = value;
      }
    }
  
    // Remove specific params
    delete object.search;
    delete object.page;
  
    // Build the new search string
    const newParams = new URLSearchParams();
    for (const key in object) {
      if (Array.isArray(object[key])) {
        object[key].forEach((val) => newParams.append(key, val));
      } else {
        newParams.set(key, object[key]);
      }
    }
  
    // Update URL
    history({
      pathname: "/master/memberlist",
      search: `?${newParams.toString()}`,
    });
  
    // Dispatch API call
    dispatch(GetMemberlist({ ...object }));
  
    // Reset selected page
    setselectpage(0);
  };
  

  // for searchable-dropdwon
  const [selectedCorporate, setSelectedCorporate] = useState([]);
  const [optionList, setOptionList] = useState([]);
  const [error, setError] = useState("");


  const CheckboxOption = (props) => {
    return (
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null} // prevent default behavior
          className="mr-2"
        />
        <label>{props.label}</label>
      </components.Option>
    );
  };

  function handleSelect(selectedOptions) {
    const selectedIds = selectedOptions?.map((opt) => opt.value) || [];
    setSelectedCorporate(selectedIds);
  
    // Safely parse the query parameters from location.search
    const sds = location.search
      .slice(1)
      .split("&")
      .filter((item) => item.includes("=")); // Ignore empty or malformed params
    let object = {};
  
    // Extract other query params except corporateID
    sds.forEach((item) => {
      const [key, value] = item.split("=");
      if (key !== "corporateID" && value !== "undefined") {
        object[key] = value;
      }
    });
  
    // Create new query params, including resetting page to 1
    const searchParams = new URLSearchParams({
      ...object,
      page: 1, // Ensure page is reset to 1
    });
  
    // Add selected corporate IDs to URL
    selectedIds.forEach((id) => searchParams.append("corporateID", id));
  
    // Update the URL with new search parameters
    history({
      pathname: "/master/memberlist",
      search: `?${searchParams.toString()}`,
    });
  
    // Dispatch API call with selected corporate IDs and reset page
    dispatch(
      GetMemberlist({
        ...object,
        corporateID: selectedIds, // Only selected ones, not merged
        page: 1,
      })
    );
  }

  const Corporatename = useSelector(
    (state) => state?.MasterAdmin?.AllBranchList?.data
  );

  useEffect(() => {
    const con =
      Corporatename &&
      Corporatename?.map((c) => ({
        value: c._id,
        label: c.corporateName,
        color: c.status ? "black" : "#808080",
      }));
    setOptionList(con);
  }, [Corporatename]);

  // for searchable-dropdwon css
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minWidth: '150px',
      maxWidth: window?.innerWidth > 600 && '210px',
      borderColor: state.isFocused ? '#fff100' : '#ececec',
      boxShadow: 'none',
      '&:hover': { borderColor: '#ececec' },
    }),
    placeholder: (base) => ({
      ...base,
      color: '#262626',
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '2px 8px',
      height: '38px',
      overflow: 'hidden',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      color: '#262626',
      height: '38px',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: 'transparent',
      color: 'black',
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        backgroundColor: '#f8f8f8',
      },
    }),
    menuList : (provided) => ({
      ...provided,
      maxHeight : '200px',
      overflowY : 'auto',
      padding: 0,
    }),
  };

  useEffect(() => {
    const newlimit = searchParams.get("limit");
    if (newlimit?.length > 0) {
      setpage(newlimit);
    }
  }, []);

  useEffect(() => {
    const newcorporateID = searchParams.get("corporateID");
    if (newcorporateID?.length > 0 && newcorporateID !== null) {
      setSelectedCorporate(newcorporateID);
    }
  }, []);

  useEffect(() => {
    const newpage = searchParams.get("page");
    if (newpage?.length > 0 && newpage !== null) {
      setselectpage(Number(newpage) - Number(1));
    }
  }, [searchParams]);

  const [showdelete, setshowdelete] = useState(false);
  const [selectionRange, setSelectionRange] = useState(null);

  useEffect(() => {
    if (selectedCorporate?.length > 0 || selectionRange?.startDate || selectionRange?.endDate) {
      setshowdelete(true);
    } else {
      setshowdelete(false);
    }
  }, [selectedCorporate, selectionRange]);

  const handlecorporatedelete = () => {
    searchParams.delete("corporateID");
    searchParams.delete("startDate");
    searchParams.delete("endDate");

    setSelectionRange(null);
    setopenCalender(false);
    setSelectedCorporate([]);
    setSearchParams(searchParams);
    const sds = location.search.slice(1).split("&");
    let object = {};
    if (location.search.includes("?")) {
      sds.map((item) => {
        let newItem = item.split("=");
        object[newItem[0]] = newItem[1];
      });
    }
    delete object.corporateID;
    delete object.startDate;
    delete object.endDate;
    dispatch(GetMemberlist({ ...object }));
  };

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  //for pagination
  const reactPaginate = {
    previousLabel: "<",
    nextLabel: ">",
    breakLabel: "",
    pageCount: Itemperpage,
    onPageChange: handlePageChange,
    containerClassName: "pagination",
    previousLinkClassName: "pagination__link",
    nextLinkClassName: "pagination__link",
    disabledClassName: "pagination__link--disabled",
    activeClassName: "pagination__link--active",
    forcePage: selectpage,
  };

  // for loader
  const loader = useSelector((state) => state?.MasterAdmin?.corporateloader);

  const [openCalender, setopenCalender] = useState(false);
  const [unixstartDate, setUnixStartDate] = useState(new Date(new Date().setUTCHours(0, 0, 0, 0))?.getTime());
  const [unixendDate, setUnixendDate] = useState(new Date(new Date().setUTCHours(23, 59, 59, 999))?.getTime());
  function formatDate(date) {
    const options = { day: "numeric", month: "short", year: "numeric" };
    return date.toLocaleDateString(undefined, options);
  }

  const ref = useRef();
  UseOutsideClick(ref, () => {
    if (openCalender) {
      setopenCalender(false);
    }
  });

  const handleSelection = (range) => {
    setSelectionRange({
      startDate: range.selection.startDate,
      endDate: range.selection.endDate,
      key: "selection",
    });
  
    const startDateText = formatDate(range.selection.startDate);
    const endDateText = formatDate(range.selection.endDate);
  
    const unix_timestamp = new Date(
      new Date(startDateText).setUTCHours(23, 59, 59, 999)
    ).getTime();
  
    const unix_timestamp1 = Math.floor(
      new Date(endDateText).getTime() + 86400000
    );
  
    setUnixStartDate(unix_timestamp);
    setUnixendDate(unix_timestamp1);
  
    const sds = location.search.slice(1).split("&");
    let object = {};
  
    if (location.search.includes("?")) {
      sds.forEach((item) => {
        const [key, value] = item.split("=");
        if (key !== "page") {
          object[key] = value;
        }
      });
    }
  
    // Ensure corporateID is sent as an array, if present
    if (object.corporateID) {
      object.corporateID = Array.isArray(object.corporateID)
        ? object.corporateID
        : [object.corporateID];
    }
  
    // Add or update query parameters
    const updatedParams = {
      ...object,
      startDate: unix_timestamp,
      endDate: unix_timestamp1,
      page: 1, // Always reset to page 1
    };
  
    // Push updated URL
    history({
      pathname: "/master/memberlist",
      search: "?" + new URLSearchParams(updatedParams).toString(),
    });
  
    // Dispatch API call with updated parameters
    dispatch(GetMemberlist(updatedParams));
  };
  
  

  function formattedStartDate(d) {
    let month = String(d?.getMonth() + 1);
    let day = String(d?.getDate());
    const year = String(d?.getFullYear());

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return `${day}/${month}/${year}`;
  }

  const handleExportData = () => {
    const sds = location.search.slice(1).split("&");
    let object = {};

    if (location.search.includes("?")) {
      sds.forEach((item) => {
        const [key, value] = item.split("=");

        if (object[key]) {
          if (Array.isArray(object[key])) {
            object[key].push(value);
          } else {
            object[key] = [object[key], value];
          }
        } else {
          object[key] = value;
        }
      });
    }

    // Ensure 'corporateID' is always an array
    if (object.corporateID && !Array.isArray(object.corporateID)) {
      object.corporateID = [object.corporateID];
    }

    // Remove unwanted query params
    delete object.page;
    delete object.limit;

    // Dispatch the export action
    dispatch(ExportBranchData({ ...object }));
    dispatch(MasterAdminLoader());
  };


  // send Mail
  const handleMail = (id) => {
    dispatch(MemberSendMail(id));
    dispatch(MasterAdminLoader())
  }
  return (
    <>
      {loader && (
        <div>
          <div className="bg-black fixed  top-0 left-0 right-0 w-full h-full z-[999] bg-opacity-50">
            <div className="z-[50] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <Loader />
            </div>
          </div>
        </div>
      )}
      <MasterAdminLayout>
        <div className="flex flex-col h-full px-5 py-[20px] xl:py-[30px] 2xl:justify-between">
          {/* {/ --------------------------------------------Search Bar---------------------------------------------------------- /} */}
          <div className="bg-white p-4 rounded-lg  w-full mb-5">
            <div className=" flex flex-col lg:flex-row gap-3 md:gap-0  justify-start items-start lg:justify-between lg:items-center">
              <div className="relative">
                <div className="absolute top-[8px] left-[20px] text-gray-400 text-2xl">
                  <RiSearch2Line className="w-6 h-6" />
                </div>
                <form
                  onSubmit={(e) => {
                    e?.preventDefault();
                    if (Search.trim() !== "") {
                      submitsearch(e);
                    }
                  }}
                >
                  <input
                    className="h-full bg-[#FFFCE1] border rounded-[8px] py-2 pl-[50px] w-[250px] placeholder:text-[#47505F]  placeholder:text-[14px] placeholder:font-medium outline-[#FCDD00]"
                    placeholder="Search By Member Name"
                    value={Search}
                    type="text"
                    onChange={(e) => {
                      const inputValue = e.target.value.trimStart();
                      setSearch(inputValue);
                      if (inputValue.trim() === "") {
                        removeQueryParams();
                      }
                    }}
                  />
                </form>
              </div>
              <div className=" flex flex-wrap items-center md:justify-end rounded-[8px] gap-4 mt-3 lg:mt-0">
                {showdelete && (
                  <div className="flex gap-3">
                    <button
                      className="bg-[#FCDD00] py-1 px-3  rounded-[4px] del-tooltip"
                      onClick={handlecorporatedelete}
                    >
                      <img src={ClearFilter} alt="new"></img>
                      <span className="del-tooltiptext !z-20">Clear Filter</span>
                    </button>
                  </div>
                )}

                <Select
                  className="w-[210px]"
                  options={optionList?.map((option) => ({
                    ...option,
                    label:
                      option.label.length > 17
                        ? option.label.slice(0, 17) + "..."
                        : option.label,
                  }))}
                  placeholder="Select Branch"
                  value={optionList?.filter((option) =>
                    selectedCorporate?.includes(option.value)
                  )}
                  onChange={handleSelect}
                  isSearchable={true}
                  closeMenuOnSelect={false}
                  isMulti={true}
                  isClearable={false}
                  styles={customStyles}
                  hideSelectedOptions={false}
                  components={{ Option: CheckboxOption, IndicatorSeparator: () => null }}
                />

                <div className=" relative ">
                  <button
                    className=" bg-[#fae006] flex px-4 rounded-[8px] py-2 font-medium"
                    onClick={() => setopenCalender(!openCalender)}
                  >
                    <img src={calender} className="mr-[12px]" alt="calenderimg"></img>
                    {selectionRange
                      ? `${formattedStartDate(selectionRange.startDate)} - ${formattedStartDate(selectionRange.endDate)}`
                      : "Select Date"}
                  </button>
                  {openCalender && (
                    <div className=" absolute md:right-0 z-50" ref={ref}>
                      <DateRangePicker
                        ranges={[
                          selectionRange || {
                            startDate: new Date(),
                            endDate: new Date(),
                            key: "selection",
                          },
                        ]}
                        onChange={handleSelection}
                        rangeColors={["#FCDD00"]}
                        showSelectionPreview={true}
                        moveRangeOnFirstSelection={false}
                        maxDate={new Date()}
                        popperProps={{
                          strategy: "fixed",
                        }}
                        direction="horizontal"
                      />
                    </div>
                  )}
                </div>
                <button className=" bg-[#fae006] flex px-4 rounded-[8px] py-2 font-medium" onClick={() => handleExportData()}>
                  Export
                </button>
              </div>

              {error && <p className="text-[#ff0000]">{error}</p>}
            </div>
          </div>
          {/* {/ --------------------------------------------Content Table------------------------------------------------------- /} */}
          <div className="w-full h-[520px] xl:h-[610px] overflow-auto scrollbar-thumb-[#FCDD00] scrollbar-thin scrollbar-track-gray-100">
            {Employeelist?.corporateData?.length === 0 ? (
              <div className="flex justify-center items-center h-full">
                <p className="font-Roboto text-xl ">
                  No Member Details Available.
                </p>
              </div>
            ) : (
              <table className="corporate-table w-[100%]  text-left font-Poppins">
                <thead>
                  <tr style={{ zIndex: 10 }}>
                    <th>
                      <div className="pl-[40px] py-3 xl:py-5 min-w-[200px]">
                        Branch Name
                      </div>
                    </th>
                    <th>
                      <div className="min-w-[200px]">Member Name</div>
                    </th>
                    <th>
                      <div className="min-w-[250px]">Email Id</div>
                    </th>
                    <th>
                      <div className="min-w-[160px]">Contact No.</div>
                    </th>
                    <th><div className="min-w-[120px]">Action</div></th>
                  </tr>
                </thead>
                <tbody>
                  {Employeelist?.corporateData?.map((user, index) => (
                    <tr key={index}>
                      <td className="pl-[40px] capitalize py-2 xl:py-4 h-[46px]">
                        {user?.branchName && user?.branchName ? (
                          user.branchName?.length > 30 ? (
                            <div className="tooltip">
                              <span>
                                {user.branchName?.substring(0, 30)}...
                              </span>
                              <span className="tooltiptext">
                                {user.branchName}
                              </span>
                            </div>
                          ) : (
                            <span>{user.branchName}</span>
                          )
                        ) : (
                          <span>-</span>
                        )}
                      </td>
                      {user?.name?.length > 30 ? (
                        <td>
                          <div className="tooltip capitalize">
                            {`${user?.name?.substring(0, 30)}...`}
                            <span className="tooltiptext">{user.name}</span>
                          </div>
                        </td>
                      ) : (
                        <td className="capitalize">
                          <div>{user.name}</div>
                        </td>
                      )}

                      {user?.email?.length > 35 ? (
                        <td>
                          <div className="tooltip">
                            {`${user?.email?.substring(0, 35)}...`}
                            <span className="tooltiptext">{user.email}</span>
                          </div>
                        </td>
                      ) : (
                        <td>
                          <div>{user.email}</div>
                        </td>
                      )}

                      <td>{user.contact}</td>
                      <td>
                        <div className="flex ml-3">
                          {/* mail btn  */}
                          <span className="text-xl">
                            <AiOutlineMail
                              className="cursor-pointer"
                              onClick={() => handleMail(user?._id)}
                            />
                          </span>

                        </div>
                      </td>

                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
          {/* {/ --------------------------------------------Footer---------------------------------------------------------- /} */}
          <div className="footer-content mt-5 ">
            <div className=" md:flex justify-between items-center ">
              <div className="flex gap-2 items-center mb-3 md:mb-0">
                <p className="capitalize">View</p>
                <div className="">
                  <Menu as="div" className="relative text-left">
                    <div>
                      <Menu.Button className="flex px-[10px] ml-[24px] min-h-[37px] bg-white border-2 border-[#F2F2F2] min-w-[60px] rounded-[8px] justify-between  text-sm font-poppins font-medium  items-center ">
                        <p className="text-[#47505F] font-medium font-[poppins]">
                          {page}
                        </p>
                        <img src={LimitArrow} alt="LimitArrow" />
                      </Menu.Button>
                    </div>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className="bottom-full absolute right-0 z-10 mt-2 py-2 w-[70%] rounded-[12px] bg-white shadoe-sm focus:outline-none border  mb-2">
                        {itemsPerPageOptions?.map((e) => (
                          <div key={e?.id}>
                            <Menu.Item>
                              {({ active }) => (
                                <p
                                  className={classNames(
                                    active ? "bg-[#FFFCE1] text-[#1A1A1A]" : "",
                                    "block px-2 py-2 text-sm cursor-pointer"
                                  )}
                                  onClick={() => onselectedpage(e)}
                                >
                                  {e?.value}
                                </p>
                              )}
                            </Menu.Item>
                          </div>
                        ))}
                      </Menu.Items>
                    </Transition>
                  </Menu>
                </div>
              </div>
              {/* {/ --------------------------------------------Footer Pagination---------------------------------------------------------- */}
              <div className="flex items-center mt-3 md:mt-0">
                <button
                  className="cursor-pointer text-[#000] text-base border border-[#D1D5DB] px-[15px] py-[4.5px] md:py-[5.5px]"
                  onClick={handleFirstPage}
                >
                  &lt;&lt;
                </button>
                <div className="hidden md:block">
                  <ReactPaginate
                    {...reactPaginate}
                    breakLabel="..."
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                  />
                </div>
                <div className="md:hidden">
                  <ReactPaginate
                    {...reactPaginate}
                    marginPagesDisplayed={0}
                    pageRangeDisplayed={1}
                  />
                </div>
                <button
                  className="cursor-pointer text-[#000] text-base border border-[#D1D5DB] px-[15px] py-[4.5px] md:py-[5.5px]"
                  onClick={handleLastPage}
                >
                  &gt;&gt;
                </button>
              </div>
            </div>
          </div>
        </div>

      </MasterAdminLayout>
    </>
  );
};
export default MemberList;
